import { render, staticRenderFns } from "./FndMenuDetail.vue?vue&type=template&id=f65fd5a6&"
import script from "./FndMenuDetail.vue?vue&type=script&lang=js&"
export * from "./FndMenuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports